if (!customElements.get('seo-details-accordion')) {
    customElements.define('seo-details-accordion', class SeoDetailsAccordion extends HTMLElement {
      constructor() {
        super();
      }

      // 类似于 Mounted 钩子函数，在元素插入到文档时调用。
      connectedCallback () {
        this.init();
      }

      // 初始化函数
      init () {
        this.el = this.querySelector('details');

        this.summary = this.querySelector('summary');

        this.content = this.summary.nextElementSibling;

        this.animation = null;

        this.isClosing = false;

        this.isExpanding = false;

        if (!this.dataset.ignoreSetupEvent) {
          this.setupEventListener();
        }
      }

      // 事件监听
      setupEventListener () {
        this.onClickSummaryHandler = this.onClick.bind(this);
        this.summary.addEventListener('click', this.onClickSummaryHandler);
      }

      // 点击事件
      onClick (e) {
        // 阻止默认行为
        e.preventDefault();
        this.toggleContent();
      }

      toggleContent () {
        this.el.style.overflow = 'hidden';
        if (this.isClosing || !this.el.open) {
          // 如果当前处于收起状态，被点击则展开
          this.open();
        } else if (this.isExpanding || this.el.open) {
          // 收缩
          this.shrink();
        }
      }

      // 类似于 Unmounted 钩子函数，在元素从文档中移除时调用。
      disconnectedCallback () {
        this.summary.removeEventListener('click', this.onClickSummaryHandler);
      }

      shrink () {

        this.summary.setAttribute('aria-expanded', false)

        this.isClosing = true;

        const startHeight = `${this.el.offsetHeight}px`;

        // 计算summary的高度
        let endHeight = `${this.summary.offsetHeight}px`;

        // 如果当前动画正在执行
        if (this.animation) {
          // 取消动画
          this.animation.cancel();
        }

        this.animation = this.el.animate({
          height: [startHeight, endHeight]
        }, {
          duration: 400,
          easing: 'ease-out'
        });

        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => this.isClosing = false;
      }

      open () {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        window.requestAnimationFrame(() => this.expand());
      }

      expand () {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        let endHeight;
        this.summary.setAttribute('aria-expanded', true);
        endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

        if (this.animation) {
          this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate({
          height: [startHeight, endHeight]
        }, {
          duration: 400,
          easing: 'ease-out'
        });

        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => this.isExpanding = false;
      }

      onAnimationFinish (open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        this.el.style.height = this.el.style.overflow = '';
      }

    })
  }
